import type { AgentSetPasswordSettingsInput } from '../../../base-api/Api'
import { api } from '../../api'

export const getAgentPasswordSettings = async () => {
  return await api.v1.agentGetPasswordSettings()
}

export const setAgentPasswordSettings = async (
  data: AgentSetPasswordSettingsInput,
) => {
  return await api.v1.agentSetPasswordSettings(data)
}
